import { DOC_HOST } from '../../base/constants/cgi-base';
/**
 * 设置文档标题
 */
export var DOC_CHANGE_TITLE = "".concat(DOC_HOST, "/cgi-bin/online_docs/doc_changetitle");
/**
 * 收藏
 */
export var DOC_COLLECT = "".concat(DOC_HOST, "/cgi-bin/online_docs/doc_collect");
/**
 * 获取文档的收藏状态
 */
export var GET_DOC_COLLECT_STATE = "".concat(DOC_HOST, "/cgi-bin/online_docs/doc_getcollect");
/**
 * 获取文档元数据信息
 */
export var DOC_INFO = "".concat(DOC_HOST, "/cgi-bin/online_docs/doc_info");
/**
 * @deprecated 后台建议不要再使用。用 fileInfo 或者 doc_info
 * 【兼容方案】drive 品类的 data/get 方法
 * 用于暂时替代没有数据直出 basicClientVars 场景的数据初始化
 */
export var DOC_META_INFO = "".concat(DOC_HOST, "/dop-api/drive/data/get");
/**
 * drive 文件信息
 */
export var FILE_INFO = '/v2/drive/fileInfo';
/**
 * 获取认证信息
 */
export var DOC_PRELOAD = "".concat(DOC_HOST, "/cgi/gateway/preload");
/**
 * 获取文档所有者 VIP 信息
 */
export var DOC_OWNER_VIP_LEVEL = '/api/personalize/owner/viplevel';
